import React from "react";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import { ShieldCheck, UserGear, ClockCounterClockwise } from "@phosphor-icons/react";
import RoleMatrixTab from "./permissions/RoleMatrixTab";
import UserOverridesTab from "./permissions/UserOverridesTab";
import HistoryTab from "./permissions/HistoryTab";

export default function Permissions() {
  return (
    <div className="p-6 md:p-8" data-testid="permissions-page">
      <div className="mb-6">
        <div className="overline">Access Control</div>
        <h1 className="font-display text-3xl font-bold text-slate-900">Permission Access Management</h1>
        <p className="mt-1 max-w-2xl text-sm text-slate-500">
          Control what every role can do across the system, and grant or restrict specific
          abilities for individual users. Changes apply immediately — the Super Admin account
          always keeps full access.
        </p>
      </div>

      <Tabs defaultValue="matrix">
        <TabsList data-testid="permissions-tabs">
          <TabsTrigger value="matrix" data-testid="tab-role-matrix">
            <ShieldCheck size={16} className="mr-1.5" /> Role Matrix
          </TabsTrigger>
          <TabsTrigger value="users" data-testid="tab-user-overrides">
            <UserGear size={16} className="mr-1.5" /> User Overrides
          </TabsTrigger>
          <TabsTrigger value="history" data-testid="tab-history">
            <ClockCounterClockwise size={16} className="mr-1.5" /> Change History
          </TabsTrigger>
        </TabsList>
        <TabsContent value="matrix"><RoleMatrixTab /></TabsContent>
        <TabsContent value="users"><UserOverridesTab /></TabsContent>
        <TabsContent value="history"><HistoryTab /></TabsContent>
      </Tabs>
    </div>
  );
}
